import React, { useCallback, useState } from 'react';
import Header from 'src/routes/Layout/Header';
import { Container } from 'src/routes/Layout/Page/styles';
import fleetsService from 'src/service/fleetsService';
import { Content, LocalHeader, Title } from '../ReservationReport/styles';
import DataGrid from './components/DataGrid';
import FormNewVehicle from './components/FormNewVehicle';
import FormNewBatch from './components/FormNewBatch';
import ButtonModal from './components/ButtonModal';
import usePaginationObservable from 'src/hooks/usePagination';
import Refresh from '../ReservationReport/components/Refresh';
import Filters from './components/Filters';

const Vaccination = () => {
  const [params, mergeParams, loading, data, error, , refresh] = usePaginationObservable(
    params => fleetsService.listVehicles(params),
    {},
    []
  );

  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenBatch, setModalOpenBatch] = useState(false);

  const handleModalClose = () => {};

  const handleModalCancel = () => {
    setModalOpen(false);
  };
  const handleModalBatchCancel = () => {
    setModalOpenBatch(false);
  };

  const handleModalBack = () => {
    setModalOpen(false);
  };

  const handleModalBatchBack = () => {
    setModalOpenBatch(false);
  };

  const openModal = () => {
    setModalOpen(true);
  };

  const openModalBatch = () => {
    setModalOpenBatch(true);
  };

  const handleRefresh = useCallback(async () => {
    try {
      refresh();
      return Promise.resolve();
    } catch (err) {
      return Promise.reject(err);
    }
  }, [refresh]);

  return (
    <Container>
      <Header 
      />
      <Content>
        <LocalHeader>
          <Title>Frotas</Title>
          <Refresh onClick={handleRefresh} loading={loading} />
          <ButtonModal onClick={openModalBatch} title='Novo Lote'/>
          <ButtonModal onClick={openModal} title='Novo Cadastro'/>
        </LocalHeader>
        <FormNewVehicle 
          open={modalOpen}
          handleClose={handleModalClose}
          handleBack={handleModalBack}
          handlecancel={handleModalCancel}
          />
        <FormNewBatch 
          open={modalOpenBatch}
          handleBack={handleModalBatchBack}
          handlecancel={handleModalBatchCancel}
        />
        <Filters params={params} mergeParams={mergeParams} />
        <DataGrid
          params={params}
          mergeParams={mergeParams}
          loading={loading}
          error={error}
          data={data}
        />
      </Content>
    </Container>
  );
};

export default Vaccination;
